<template>
  <div>
    <Breadcrumb >
      <BreadcrumbItem>首页</BreadcrumbItem>
      <BreadcrumbItem>通知管理</BreadcrumbItem>
      <BreadcrumbItem>短信列表</BreadcrumbItem>
    </Breadcrumb>
    <div class="single-page ivu-article">
      <div>
        <Form :label-width="60" inline>
          <FormItem label="活动名称">
            <Input v-model="searchMeeting" clearable @on-enter="search(1)" ></Input>
          </FormItem>
          <FormItem label="手机号">
            <Input v-model="searchMobile" clearable @on-enter="search(1)" ></Input>
          </FormItem>
          <FormItem label="短信内容">
            <Input v-model="searchTextContent"  clearable @on-enter="search(1)"></Input>
          </FormItem>
          <FormItem label="通知类型">
            <Select v-model="searchTextType" >
              <Option value="ALL">全部</Option>
              <Option value="SIGN_ADUIT_PASS">审核报名通过</Option>
              <Option value="SIGN_ADUIT_REFUSE">审核报名拒绝</Option>
              <Option value="SMS_TYPE_NOTIFICATION">参会提醒</Option>
            </Select>
          </FormItem>
          <FormItem>
            <Button type="primary" @click="search(1)">搜索</Button>
          </FormItem>
        </Form>
      </div>
      <Card >
        <p slot="title">
          <Icon type="ios-list-outline"></Icon>
          短信列表
          <Input >
          <Button slot="append" icon="ios-search"></Button>
          </Input>
        </p>
        <Table :columns="columns" :data="rows" :show-header="true"></Table>
        <Page :total="totalCount" :page-size="pageSize" :current.sync="currentPage" show-total show-elevator @on-change="handlePageChange" style="margin-top: 10px; text-align: right" />
      </Card>
    </div>
  </div>
</template>
<script>

import Vue from 'vue'
import moment from 'moment'
import { mapState } from 'vuex'

export default {
  name: 'TextMessageList',
  data () {
    return {
      totalCount: 0,
      pageSize: 10,
      currentPage: 1,
      remoteStatus: null,
      textMessageList: [],
      tableLoading: true,
      searchMeeting: '',
      searchMobile: '',
      searchTextContent: '',
      searchTextType: 'ALL',
      columns: [
        {
          title: 'ID',
          key: 'id',
          width: 80
        },
        {
          title: '活动名称',
          key: 'meetingTitle'
        },
        {
          title: '发送时间',
          key: 'updateDate',
          width: 105,
          render: (h, params) => {
            return h('span', this.formatDate(params.row.updateDate))
          }
        },
        {
          title: '通知类型',
          key: 'type',
          width: 120,
          render: (h, params) => {
            return h('span', this.getTypeText(params.row.type))
          }
        },
        {
          title: '手机号',
          key: 'mobile',
          width: 120
        },
        {
          title: '短信内容',
          key: 'content'
        },
        {
          title: '发送结果',
          key: 'send_result',
          width: 130,
          render: (h, params) => {
            return h('span', this.getResultText(params.row))
          }
        }
      ]
    }
  },
  computed: {
    ...mapState({
      loginUser: 'user'
    }),
    rows () {
      return this.textMessageList
    }
  },
  methods: {
    getResultText (row) {
      if (row.has_sent === 0) {
        return '等待发送'
      } else {
        if (row.send_result) {
          return row.send_result
        } else {
          return '已发送'
        }
      }
    },
    getTypeText (type) {
      if (type === 'SIGN_ADUIT_PASS') {
        return '审核报名通过'
      } else if (type === 'SIGN_ADUIT_REFUSE') {
        return '审核报名拒绝'
      } else if (type === 'SMS_TYPE_NOTIFICATION') {
        return '参会提醒'
      } else {
        return type
      }
    },
    formatDate (timestamp) {
      if (timestamp) {
        return moment(timestamp).format('YYYY-MM-DD HH:mm:ss')
      } else {
        return null
      }
    },
    beforeSave () {
      this.$Message.destroy()
      this.$Loading.start()
    },
    afterSave (e) {
      this.$Loading.finish()
      if (e) {
        this.$Message.error({
          content: e.body.error || '操作失败，请重试',
          duration: 0,
          closable: true
        })
      } else {
        this.$Message.success('操作成功！')
      }
    },
    handlePageChange () {
      this.search(this.currentPage)
    },
    async search (startPage) {
      try {
        this.$Loading.start()
        let queryStr = `page=${startPage}&size=${this.pageSize}&meeting=${this.searchMeeting}&mobile=${this.searchMobile}&content=${this.searchTextContent}&type=${this.searchTextType}`
        let resp = (await this.$http.get(`/api/admin/message/mobileText?${queryStr}`)).body
        this.totalCount = resp.totalCount
        this.totalPage = resp.totalPage
        this.textMessageList = resp.mobileTextRecords
        this.$Loading.finish()
      } catch (e) {
        this.afterSave(e)
      }
    }
  },
  async beforeRouteEnter (to, from, next) {
    try {
      let resp = await Vue.http.get('/api/admin/message/mobileText?page=1&size=50')
      next(vm => {
        vm.remoteStatus = resp.status
        vm.totalCount = resp.body.totalCount
        vm.totalPage = resp.body.totalPage
        vm.textMessageList = resp.body.mobileTextRecords
        vm.searchKeyword = null
      })
    } catch (e) {
      next(vm => {
        vm.remoteStatus = e.status
        vm.textMessageList = []
      })
    }
  },
  async beforeRouteUpdate (to, from, next) {
    try {
      let resp = await Vue.http.get(`/api/admin/message/mobileText?page=1&size=${this.pageSize}`)
      this.remoteStatus = resp.status
      this.totalCount = resp.body.totalCount
      this.totalPage = resp.body.totalPage
      this.textMessageList = resp.body.mobileTextRecords
      this.searchKeyword = null
      next()
    } catch (e) {
      this.remoteStatus = e.status
      this.textMessageList = []
      next()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/message/TextMessageList.vue